module.exports = __webpack_public_path__ + "assets/SF-on-lottery-c190a1d6.png";